export const text = {
  LICENSES: 'Licenses',
  NO_LICENSES_ADDED: 'No licenses added.',
  LICENSE_NO: 'License no.',
  LICENSED_BY: 'Licensed by',
  VISIT_TYPES: 'Visit type(s)',
}
